import { Component, Input, OnInit, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

import { Moment } from 'moment';

@Component({
  selector: 'filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent implements OnInit {
  @Input() filter: any;

  @Input() statusFilter: string;

  @Output() passFilter: EventEmitter<any> = new EventEmitter();

  @Output() reloadEvent: EventEmitter<any> = new EventEmitter();

  constructor(private eRef: ElementRef) {}

  ngOnInit(): void {}

  @HostListener('document:click', ['$event'])
  clicked(event: any): void {
    if (!this.eRef.nativeElement.contains(event.target)) {
      console.log('click out');
    }
  }

  applyFilter(value: string | number | Moment | null | any, attribute: string): void {
    this.passFilter.emit({ value, attribute });
  }

  reload(): void {
    this.reloadEvent.emit(true);
  }
}
